// recaptcha-loader.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaLoaderService {

  private loaded = false;
  private loadingPromise: Promise<void>;

  load(siteKey: string): Promise<void> {

    if (this.loaded) {
      return Promise.resolve();
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise((resolve, reject) => {

      const existing = document.querySelector(
        'script[src*="recaptcha/api.js"]'
      );

      if (existing) {
        this.loaded = true;
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.loaded = true;
        resolve();
      };

      script.onerror = reject;

      document.head.appendChild(script);

    });

    return this.loadingPromise;
  }
}